import { Injectable } from '@angular/core';
import { pageType } from '../utility/constants';

@Injectable({
  providedIn: 'root'
})
export class CommonGetScreenService {
  constructor() {}

  public getScreenFromUrl(isFrom: string, currentUrl: string): string {
    const url = currentUrl;

    if (url.includes(pageType.flightInformation) && isFrom === pageType.mawb) {
      return pageType.mawbFlight;
    } else if (url.includes(pageType.commodityInfo)) {
      return pageType.commodity;
    } else if (url.includes(pageType.bag)) {
      return pageType.bag;
    } else if (url.includes(pageType.mawb)) {
      return pageType.mawb;
    } else if (url.includes(pageType.manifest)) {
      return pageType.manifest;
    } else if (url.includes(pageType.mawbFlight)) {
      return pageType.mawbFlight;
    } else if (url.includes(pageType.pieceInfo) && isFrom === pageType.manifest) {
      return pageType.bagShipment;
    } else if (url.includes(pageType.accountInformation)){
      return pageType.account;
    } else {
      return pageType.hawb;
    }
  }
}
